import React from 'react';
import classNames from 'classnames';
var optionClasses = function optionClasses(props) {
  return classNames('prui-select__option', {
    'prui-select__option--disabled': props.disabled
  });
};
var Option = function Option(props) {
  var value = props.value,
    name = props.name,
    disabled = props.disabled;
  return /*#__PURE__*/React.createElement("option", {
    className: optionClasses(props),
    value: value,
    disabled: disabled,
    style: disabled ? {
      color: '#d4d4d4'
    } : {}
  }, name);
};
Option.defaultProps = {
  disabled: false
};
export default Option;